import { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { Link } from "react-router-dom";
import { ReactComponent as Dashboard } from "../../../assets/img/icon/dashboard_black_24dpt.svg";
import { ReactComponent as Description } from "../../../assets/img/icon/description_black_24dpt.svg";
import { ReactComponent as MaskIcon } from "../../../assets/img/icon/masks_black_24dpt.svg";
import { ReactComponent as People } from "../../../assets/img/icon/people_black_24dpt.svg";
import { ReactComponent as Person } from "../../../assets/img/icon/person_black_24dpt.svg";
import { ReactComponent as ChatIcon } from "../../../assets/img/icon/question_answer_black_24dpt.svg";
import { COLOR } from "../../../config/constant";
import { client } from "../../../services/mqttService/mqttService";
import { GlobalContext } from "../../contexts/globalContext";
import Alert from "../../ui/atoms/Alert/Alert";
import Confirm from "../../ui/atoms/Confirm/Confirm";
import Loader from "../../ui/atoms/Loader/Loader";
import Toast from "../../ui/atoms/Toast/Toast";
import AsideDashboard from "../../ui/organisms/AsideDashboard/AsideDashboard";
import NavbarDashboard from "../../ui/organisms/NavbarDashboard/NavbarDashboard";
import Sidebar from "../../ui/organisms/Sidebar/Sidebar";
import style from "./DashboardTemplate.module.css";
const iconStyle = "w-6 sm:w-8 xl:w-10 h-6 sm:h-8 xl:h-10 mx-auto fill-current";

let PAGE_LIST = [
  {
    label: "dashboard",
    icon: <Dashboard className={iconStyle} />,
    path: "/",
  },
  {
    label: "pasien",
    icon: <People className={iconStyle} />,
    path: "/patient",
  },
  {
    label: "rekam",
    icon: <Description className={iconStyle} />,
    path: "/record",
  },
  {
    label: "perangkat",
    icon: <MaskIcon className={iconStyle} />,
    path: "/device",
  },
  {
    label: "profil",
    icon: <Person className={iconStyle} />,
    path: "/profile",
  },
];
if (process.env.NODE_ENV === "development") {
  PAGE_LIST = [
    ...PAGE_LIST,
    {
      label: "percakapan",
      icon: <ChatIcon className={iconStyle} />,
      path: "/message",
    },
  ];
}

const DashboardTemplate = (props) => {
  const history = useHistory();
  const [sharedState, dispatch] = useContext(GlobalContext);

  const location = useLocation();
  const setPage = (page) => {
    history.push(`${page}`);
  };
  const [active, setActive] = useState("");
  const [showSidebar, setShowSidebar] = useState(false);

  useEffect(() => {
    const path = location.pathname;
    let updatedActive = "";
    if (path === "/") updatedActive = "/";

    if (updatedActive === "")
      PAGE_LIST.forEach((page) => {
        if (path.includes(page.path)) updatedActive = page.path;
      });
    if (active !== updatedActive) setActive(updatedActive);

    const locationSplitted = location.pathname.split("/");
    window.scrollTo({
      top: locationSplitted.length <= 2 ? 0 : 180,
      left: 0,
      behavior: "smooth",
    });
  }, [location.pathname]);

  const hideAlert = () => {
    dispatch("alert", { show: false });
  };

  const hideConfirm = () => {
    dispatch("confirm", { show: false });
  };

  const hideToast = () => {
    dispatch("toast", "");
  };

  const sidebarToggler = () => {
    setShowSidebar(!showSidebar);
  };

  const handleConnect = () => {
    client.on("message", (topic, message) => {
      if (topic !== `notification/${sharedState.user._id}`) return null;
      message = JSON.parse(message.toString()) || {};
      if (message.model === "record") {
        const info = message.message || "";
        const id = info.split(":")[1] ? info.split(":")[1] : "";
        dispatch(
          "toast",
          <div>
            Anda memiliki{" "}
            <Link
              to={{
                pathname: `/record/${id}`,
                state: { prevPath: location.pathname },
              }}
            >
              <span className="text-primary">rekam medis</span>{" "}
            </Link>{" "}
            baru.{" "}
          </div>
        );
      }
    });
  };

  useEffect(() => {
    handleConnect();
    if (sharedState.user._id)
      client.subscribe(`notification/${sharedState.user._id}`);
    return () => client.unsubscribe(`notification/${sharedState.user._id}`);
  }, []);

  return (
    <div
      className="min-h-screen relative pt-10 text-sm md:text-base"
      style={{ color: COLOR.DARK, backgroundColor: COLOR.WHITESMOKE }}
      id="top"
    >
      {sharedState.isLoading && <Loader />}
      <Alert data={sharedState.alert} handleClose={hideAlert} />
      <Confirm data={sharedState.confirm} handleClose={hideConfirm} />
      <Toast
        show={sharedState.toast !== ""}
        message={sharedState.toast}
        handleClose={hideToast}
      />
      <NavbarDashboard sidebarToggler={sidebarToggler} />
      <Sidebar
        PAGE_LIST={PAGE_LIST}
        showSidebar={showSidebar}
        sidebarToggler={sidebarToggler}
      />
      <div className="bg-white py-1 px-1 md:px-3 xl:container mx-auto flex justify-end xl:justify-start  flex-col-reverse xl:flex-row xl:space-x-3 z-0 overflow-x-hidden min-h-screen">
        <AsideDashboard />

        <section className="px-1 sm:px-2 md:px-3 xl:pl-6 xl:pr-6 py-6 w-full">
          {/*PAGE NAVIGATOR */}
          {/* <div className="absolute w-full left-0" style={{ top: "-41rem" }}>
            <div
              className=" bg-gray-400 mx-auto rounded-full"
              style={{ width: "100%", height: "45rem" }}
            ></div>
          </div> */}

          <div className="block overflow-x-auto py-1 sm:py-1.5 px-2 sm:px-16 md:px-36 xl:px-0 fixed border-primary border-opacity-20 border-t xl:border-t-0 bottom-0 xl:relative xl:bottom-auto left-0 xl:left-auto bg-white xl:bg-transparent  w-full xl:w-auto z-10">
            <div className="flex justify-between xl:justify-start space-x-2 xl:space-x-5 xl:border-b max-w-xl mx-auto xl:mx-0">
              {PAGE_LIST.map((page) => {
                const isActive = page.path === active;
                return (
                  <div
                    key={page.label}
                    className={
                      `
                      ${style["page-nav"]}                      
                      relative px-1 py-0.5 flex-shrink-0 cursor-pointer rounded hover:bg-white hover:bg-opacity-30 xl:hover:bg-opacity-10 xl:hover:bg-secondary group text-primary transition-opacity duration-300  ` +
                      (isActive ? "" : "text-opacity-60")
                    }
                    onClick={() => setPage(page.path)}
                  >
                    {page.icon}
                    <div
                      className={
                        "text-xs md:text-sm text-primary text-center capitalize " +
                        (isActive ? "" : "text-opacity-60")
                      }
                    >
                      {page.label}
                    </div>

                    <hr
                      className={
                        "hidden sm:block absolute w-full left-0 -bottom-1.5 xl:-bottom-1 xl:relative mt-0 xl:mt-2 border-2 bg-gray-50 xl:bg-primary border-white xl:border-primary rounded-lg transition-opacity duration-300 " +
                        (isActive ? "opacity-100" : "opacity-0")
                      }
                    />
                  </div>
                );
              })}
            </div>
          </div>

          {props.children}
          <br />
          <br />
          <br />
        </section>
      </div>
    </div>
  );
};

export default DashboardTemplate;
